import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M10.667 8.599v2.8c0 2.333-.933 3.266-3.266 3.266H4.6c-2.334 0-3.267-.933-3.267-3.266v-2.8c0-2.334.933-3.267 3.267-3.267h2.8c2.333 0 3.266.933 3.266 3.267"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M14.667 4.599v2.8c0 2.333-.933 3.266-3.266 3.266h-.734V8.6c0-2.334-.933-3.267-3.266-3.267H5.334v-.733c0-2.334.933-3.267 3.267-3.267h2.8c2.333 0 3.266.933 3.266 3.267"
    }, null, -1)
  ]))]))
}
export default { render: render }